module.exports = __webpack_public_path__ + "img/Frame_ItemFrame01_Color_Purple.289f0249.png";